import SamaritanFetch from "./httpClient";

export const fetchSkills = () => SamaritanFetch.v2("/skills");
